const config = {
  name: "sundance",
  features: {
    accessCodes: true,
    moreInformation: true,
    hasParkingInstructions: true,
    hasPromoCodeWarning: false,
    displayPromoTotalUses: true, // Display "Redemptions left" on promo code card
    mandatoryFields: true,
    userPhoneNumber: true,
    userName: true,
    userPostalCode: true
  },
  parkingSession: {
    // Until 11:59 PM the day prior to your reservation
    cancelDaysBefore: 1,
    cancelTime: "23:59",
    cancelTimeOptions: [],
    // Start time offset 6am
    startOffsetHrs: 6,
    // Start date offset from today (0 = today)
    startOffsetDate: 1,
    // End date offset from start time
    endOffsetDate: 200
  }
}
export default config
